
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".99","fill":"#282E3E","clip-path":"url(#clip0_1390_14237)"}},[_c('path',{attrs:{"d":"M14.96 8.329a.933.933 0 00.54.171.933.933 0 00.886-.635l.289-.89a1.25 1.25 0 01.79-.792l.907-.294A.943.943 0 0019 5.004a.933.933 0 00-.656-.892l-.89-.287a1.251 1.251 0 01-.793-.792l-.296-.904a.933.933 0 00-1.768.012l-.29.891a1.252 1.252 0 01-.773.791l-.907.294a.943.943 0 00-.627.886.933.933 0 00.64.885l.89.29a1.249 1.249 0 01.793.795l.294.904a.93.93 0 00.343.452zM21.114 11.878a.666.666 0 001.019-.332l.206-.635a.893.893 0 01.565-.566l.648-.21a.673.673 0 00.318-1.028.667.667 0 00-.339-.241l-.635-.205a.893.893 0 01-.567-.566l-.21-.646a.666.666 0 00-1.264.009l-.208.636a.895.895 0 01-.551.565l-.648.21a.674.674 0 00-.448.633.667.667 0 00.457.632l.636.207a.893.893 0 01.566.568l.21.646c.047.13.132.243.245.323z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.6 6a1.2 1.2 0 00-1.2 1.2v9.6A1.2 1.2 0 003.6 18h15.6a1.2 1.2 0 001.2-1.2v-2.03a1.2 1.2 0 012.4 0v2.03a3.6 3.6 0 01-3.6 3.6H3.6A3.6 3.6 0 010 16.8V7.2a3.6 3.6 0 013.6-3.6h4.267a1.2 1.2 0 010 2.4H3.6z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.8 10.2A1.2 1.2 0 016 9h4.8a1.2 1.2 0 010 2.4H6a1.2 1.2 0 01-1.2-1.2zM4.8 14.4A1.2 1.2 0 016 13.2h8a1.2 1.2 0 010 2.4H6a1.2 1.2 0 01-1.2-1.2z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1390_14237"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    